module.exports = __webpack_public_path__ + "img/image3.72f61d01.svg";